import { render, staticRenderFns } from "./CollegeDepartmentReport.vue?vue&type=template&id=1d328442&scoped=true"
import script from "./CollegeDepartmentReport.vue?vue&type=script&lang=js"
export * from "./CollegeDepartmentReport.vue?vue&type=script&lang=js"
import style0 from "./CollegeDepartmentReport.vue?vue&type=style&index=0&id=1d328442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d328442",
  null
  
)

export default component.exports